/* eslint-disable standard/object-curly-even-spacing */
import React, { useState } from "react";

import { graphql } from "react-apollo";
import gql from "graphql-tag";
import withSharedSnackbar from "../../HOCs/withSharedSnackbar";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, CircularProgress} from "@material-ui/core";

const CREATE_BRAND = gql`
  mutation CreateBrand($name: String!, $clientLoginId: Int!) {
    createBrand(name: $name, clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
        client_login_id
        created_at
        updated_at
      }
    }
  }
`;

const AddBrandModal = ({ open, onClose, refetchBrands, createBrand, clientLoginId, openSnackbar}) => {
  const [brandName, setBrandName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSave = async () => {
   
    if (!brandName.trim()) {
      setError("Brand name is required.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await createBrand({
        variables: { name: brandName, clientLoginId: clientLoginId },
      });

      if (data.createBrand.status) {
        refetchBrands();
        onClose();
        openSnackbar(`${data.createBrand.message}`, { variant: "success" });
      } else {
        openSnackbar(`${data.createBrand.message}`, { variant: "error" });
      }
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
    finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setBrandName("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Brand</DialogTitle>
      <DialogContent>
        <div sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Brand Name"
            variant="outlined"
            value={brandName}
            onChange={(e) => {
              setBrandName(e.target.value);
              setError("");
            }}
            error={!!error}
            helperText={error}
          />
        </div>
      </DialogContent>
      <DialogActions style={{paddingRight:"20px", marginBottom:"10px"}}>
        <Button onClick={handleCancel} variant="outlined" style={{
            borderColor: '#f44336',
            color: '#f44336',
            borderRadius: 8,
           
          }}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={loading} style={{
            backgroundColor: '#66bb6a', 
            color: '#ffffff',
            borderRadius: 8,
           
            '&:hover': {
              backgroundColor: '#81c784',
            },
          }}>
          {loading ? <CircularProgress size={24} /> : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default graphql(CREATE_BRAND, {
  name: "createBrand", 
})(withSharedSnackbar(AddBrandModal));



// WEBPACK FOOTER //
// ./src/components/Pages/modalConfigure/AddBrandModal.jsx